import { debounce } from 'lodash-es'
import { useConfirm } from './confirm'
import { copyToTeam } from '~/api'
import type { CopyToTeamRequest } from '~/api/interface/collection'
import { PageKey } from '~/constants/page'

// 复制到团队空间
export const useCopyToTeam = debounce(
  (params: CopyToTeamRequest, option?: any) => {
    const { $t } = useNuxtApp()
    const route = useRoute()
    let source = ''
    let target = ''
    let Batch = 0

    if (
      params.model_type !== undefined &&
      params.model_type !== COLLECTION_MAP.SOURCE
    ) {
      target = TAB_TRACK_KEY[params.model_type]
    } else if (params.resource_type !== undefined) {
      target = TAB_TRACK_KEY[COLLECTION_MAP.SOURCE][params.resource_type]
    }

    if (route.name === PageKey.RECENTLY_WORKS) {
      source = SOURCE.RECENTLY
    } else {
      source = SOURCE.MYSPACE
    }

    if (params.ids && params.ids.length > 1) {
      Batch = BATCH.ALL
    } else {
      Batch = BATCH.ONE
    }
    // 是否是素材PPT/PDF复制
    const isMaterial =
      params.model_type === COLLECTION_MAP.SOURCE &&
      params.resource_type === RESOURCE_TYPE.MATERIAL &&
      (params.media_type === FILE_TYPE_MAP.PPT ||
        params.media_type === FILE_TYPE_MAP.PDF)

    trackEvent(TRACK_EVENT.YOUYAN_PLATFORM_COPYTOTEAM, {
      target,
      source,
      Batch,
    })

    useConfirm({
      title: $t('fu-zhi-dao-tuan-dui-kong-jian'),
      description: isMaterial
        ? h('div', { class: 'text-left' }, [
            h('div', $t('zhi-you-guan-li-yuan-zhi-chi-shan-chu')),
            h(
              'div',
              $t(
                'tuan-dui-nei-suo-you-ren-jiang-ke-gong-tong-bian-ji-gai-su-cai'
              )
            ),
          ])
        : $t(
            'fu-zhi-dao-tuan-dui-kong-jian-hou-zhi-you-guan-li-yuan-zhi-chi-shan-chu'
          ),

      icon: true,
      okText: $t('fu-zhi'),
      onOk: async () => {
        const res = await copyToTeam({
          ...params,
        })
        if (!res.code) {
          option?.onOk?.()
          message.success($t('fu-zhi-dao-tuan-dui-kong-jian-cheng-gong'))
        }
      },
    })
  },
  200
)
